
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/selling",
      function () {
        return require("private-next-pages/selling/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/selling"])
      });
    }
  